import { LOCALE } from '../../../constants/activity-constants'

const ec = LOCALE === "es-EC"
const arg = LOCALE === "es-AR"

export let textCountryTetris = {};
if (arg) {
    textCountryTetris = {
        textTutorial1: 'Dejá caer las piezas y rellená',
        textTutorial2: 'los espacios para formar líneas',
        textTutorial3: 'aprovechalo para duplicar tus puntos!',
        textTutorial4: 'Ubicala en cualquier parte.',
        textTutorial5: '¡preparate!',
        textTutorial6: 'girá la pieza en el sentido de las agujas del reloj.',
        textTutorial7: 'mové la pieza a la izquierda.',
        textTutorial8: 'mové la pieza hacia abajo con mayor velocidad.',
        textTutorial9: 'mové la pieza a la derecha.',
        textTutorial10: 'Podés dar clic al botón finalizar',
        textTutorial11: 'si deseás terminar el juego antes de que acabe el tiempo.', 
        textTutorial12: 'Tecla de flecha hacia abajo:',
        textTutorial13: 'Dejá caer las piezas'
    }
}else{
    textCountryTetris = {
        textTutorial1: 'y ve rellenando los espacios',
        textTutorial2: 'para formar líneas.',
        textTutorial3: 'aprovéchalo para duplicar tus puntos!',
        textTutorial4: 'Ubícala en cualquier parte.',
        textTutorial5: '¡prepárate!',
        textTutorial6: 'gira la pieza en el sentido de las agujas del reloj.',
        textTutorial7: 'mueve la pieza a la izquierda.',
        textTutorial8: 'mueve la pieza hacia abajo con más velocidad.',
        textTutorial9: 'mueve la pieza a la derecha.',
        textTutorial10: 'Puedes dar clic al botón finalizar',
        textTutorial11: 'si deseas terminar el juego antes de que acabe el tiempo.',
        textTutorial12: 'Tecla de flecha abajo:',
        textTutorial13: 'Deja caer las piezas'
    }
}

export let textCountrySnake = {};
if (arg) {
    textCountrySnake = {
        textTutorial1: 'Mové',
        textTutorial2: 'y empezá a recoger todas las gotas de sangre que más podás.',
        textTutorial3: 'recojás',
        textTutorial4: 'recogelos y duplicá',
        textTutorial5: 'girá',
    }
}else{
    textCountrySnake = {
        textTutorial1: 'Mueve',
        textTutorial2: 'y empieza a recoger todas las gotas de sangre que más puedas.',
        textTutorial3: 'recojas',
        textTutorial4: 'recógelos y duplica',
        textTutorial5: 'gira',
    }
}

export let textCountryLinea3 = {};
if (arg) {
    textCountryLinea3 = {
        textTutorial1: 'Arrastrá las figuras, intercambiá posiciones',
        textTutorial2: 'juntés',
        textTutorial3: 'mové el personaje a cualquier posición a su alrededor y duplicá tus puntos.',
        textTutorial4: 'Podés',
        textTutorial5: 'deseás',
    }
}else{
    textCountryLinea3 = {
        textTutorial1: 'Arrastra las figuras, intercambia posiciones',
        textTutorial2: 'juntes',
        textTutorial3: 'mueve el personaje a cualquier posición a su alrededor y duplica tus puntos.',
        textTutorial4: 'Puedes',
        textTutorial5: 'deseas',
    }
}